import { InjectionToken } from '@angular/core';

export const ROUTE_DATE_FORMAT = new InjectionToken<string>('routeDateFormat');
export type IRouteDateFormat = string;

/**
 * Constant in the coreModule. It represents the standard way of
 * displaying date in routes.
 */
export const RouteDateFormatProvider: {
  provide: string;
  useValue: IRouteDateFormat;
} = {
  provide: 'routeDateFormat',
  useValue: 'YYYY-MM-DD',
};
